import { Clock, Zap, ShieldCheck, MapPin } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const ITEMS = [
  { icon: Clock, title: "Atendimento 24H", desc: "Estamos disponíveis todos os dias." },
  { icon: Zap, title: "Atendimento Ágil", desc: "Entre em contato e solicite seu atendimento rapidamente." },
  { icon: ShieldCheck, title: "Transporte Seguro", desc: "Cuidado durante todo o processo de remoção e transporte." },
  { icon: MapPin, title: "Jundiaí e Região", desc: "Atendimento em diversas cidades da região." },
];

export const TrustStrip = () => {
  return (
    <section className="relative z-20 border-y border-white/10 bg-surface">
      <div className="container-x grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y sm:divide-y-0 sm:divide-x divide-white/10">
        {ITEMS.map((it, i) => (
          <Reveal key={it.title} delay={i * 0.08} className="flex items-start gap-4 py-8 sm:px-7 first:sm:pl-0 last:sm:pr-0">
            <span className="shrink-0 grid place-items-center h-12 w-12 rounded-sm bg-brand text-white">
              <it.icon className="h-6 w-6" strokeWidth={2.2} />
            </span>
            <div>
              <h3 className="font-display text-xl font-bold text-white leading-none">{it.title}</h3>
              <p className="mt-1.5 text-sm text-zinc-400">{it.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
